import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  constructor(
    translate: TranslateService,
  ) {

    // translate.addLangs(['en', 'it']);
    // translate.setDefaultLang('it');
    // translate.use('it');
  }
}
